/* unplugin-vue-components disabled */import script from "./CydsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CydsDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CydsDetail.vue?vue&type=style&index=0&id=69b11d64&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b11d64"]])

export default __exports__